import moment from "moment";

export function formatDateTime(dateTime: Date) {
    return moment(dateTime).format("DD MMM YYYY HH:mm:ss");
}
